import { computed, Injectable, signal } from '@angular/core';
import { GuideTask } from '../models/guide.model';
import { GUIDE_TASKS } from '../registry/tasks';

/**
 * Loads and exposes the list of {@link GuideTask}s (the action registry).
 *
 * MVP: served from the static {@link GUIDE_TASKS} constant. Later this becomes
 * an HTTP-backed, admin-editable source — see the commented `loadRegistry()`
 * seam.
 */
@Injectable({ providedIn: 'root' })
export class ActionRegistryService {
  private readonly tasksSignal = signal<GuideTask[]>(GUIDE_TASKS);

  /** All registered guide tasks. */
  readonly tasks = this.tasksSignal.asReadonly();

  /** Tasks flagged for the empty-state quick-start list in the AI sidebar. */
  readonly featuredTasks = computed(() =>
    this.tasksSignal().filter((task) => task.isFeatured),
  );

  findTask(taskId: string): GuideTask | undefined {
    return this.tasksSignal().find((task) => task.id === taskId);
  }

  // SEAM (future backend pass): replace the static seed with a fetch.
  // loadRegistry(): Observable<GuideTask[]> {
  //   return this.http.get<GuideTask[]>(`${environment.shout_api.url}/guide/tasks`).pipe(
  //     tap((tasks) => this.tasksSignal.set(tasks)),
  //   );
  // }
}
